<!-- @Description 核心技术折叠列表项 -->
<template>
  <van-collapse v-model="activeName" accordion class="coreTechnology-list">
    <van-collapse-item
      v-for="(item, index) in data"
      :key="`coreTechnology-item${index + 1}`"
      :name="index + 1"
      class="coreTechnology-item"
      :class="[
        { 'coreTechnology-item-check': activeName == index + 1 },
        `coreTechnology-item${index + 1}`
      ]"
    >
      <template #title>
        <div class="coreTechnology-item-title">
          <div class="coreTechnology-item-title-text">{{ item.title }}</div>
          <img
            :src="arrowIcon"
            class="coreTechnology-item-arrow"
            :class="{ 'is-expanded': activeName == index + 1 }"
            alt=""
          />
        </div>
      </template>
      <div class="introduction">
        <!-- <div class="title">技术介绍</div> -->
        <div class="content">{{ item.introduction }}</div>
        <div v-if="item.highlight" class="highlight">{{ item.highlight }}</div>
      </div>
      <!-- <div class="purpose">
        <div class="title">研究目的</div>
        <div class="content">{{ item.purpose }}</div>
      </div> -->
    </van-collapse-item>
  </van-collapse>
</template>
<script>
import arrowIcon from "@/../static/img/other/arrow.svg";

export default {
  data() {
    return {
      arrowIcon,
      activeName: "",
      data: [
        {
          title: "认知规划与决策",
          introduction:
            "我们开发了一个结合神经生成、符号验证及强化学习的认知规划系统。该系统旨在透过死循环流程生成、验证及优化输出，协助我们的模型分解复杂任务、检查事实与逻辑一致性，并提升在高风险企业场景中的决策可靠性。",
          highlight: "系统地提升模型的准确性、一致性及稳健性",
          purpose: ""
        },
        {
          title: "小样本学习",
          introduction:
            "我们开发了基于非线性期望的专有算法框架，以应对工业及专业环境中的实际数据挑战，包括分布偏移、长尾标签及含噪观测。该框架专为小样本学习而设计，仅需少量带卷标样本即可实现稳健的训练及可靠的推理。即使在偏斜数据分布、环境变化或极端工业场景等复杂、动态及不确定营运条件下，仍能保持高性能及稳定的优化。",
          highlight: "平均准确率提升10%+，鲁棒性提升5倍",
          purpose: ""
        },
        {
          title: "基于知识本体的动态融合推理",
          introduction:
            "我们开发了一种将领域知识与数据驱动建模相结合的推理范式。透过将科学机制、行业标准及专家经验转化为结构化知识表示，该范式将模型输出锚定于已验证的领域知识，提升可解释性，并减少事实、逻辑及一致性错误。其已应用于智能制造及数字人客户服务等场景。",
          highlight: "在智能制造的传统缺陷检测中，平均识别准确率提升至约90%",
          purpose: ""
        }
      ]
    };
  }
};
</script>
<style lang="less" scoped>
.coreTechnology-list {
  width: 100%;
  /deep/.van-cell {
    height: 200px;
    padding: 0;
    font-size: 32px;
    color: #08204d;
    line-height: normal;
    text-align: center;
    background: transparent;
    cursor: pointer;
    .van-cell__title {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .coreTechnology-item-title {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 200px;
    padding: 0 64px;
    box-sizing: border-box;
  }
  .coreTechnology-item-title-text {
    font-size: 32px;
    color: #08204d;
    line-height: 44px;
    text-align: center;
  }
  .coreTechnology-item-arrow {
    position: absolute;
    bottom: 28px;
    left: 50%;
    height: 16px;
    width: auto;
    margin-left: -8px;
    opacity: 0.72;
    transform: rotate(90deg);
    transition: transform 0.25s ease, opacity 0.25s ease;
    animation: arrowNudge 2.2s ease-in-out infinite;
  }
  .coreTechnology-item-arrow.is-expanded {
    animation: none;
    transform: rotate(-90deg);
    opacity: 0.72;
  }
  @keyframes arrowNudge {
    0%,
    100% {
      transform: rotate(90deg) translateX(-4px);
      opacity: 0.45;
    }
    50% {
      transform: rotate(90deg) translateX(6px);
      opacity: 0.85;
    }
  }
  /deep/ .van-collapse-item__content {
    padding: 26px 64px 96px;
  }
  /deep/ .van-cell__right-icon {
    display: none;
  }
  .coreTechnology-item {
    background: #ffffff;
    .info {
      font-size: 24px;
      font-family: PingFang-SC-Regular, PingFang-SC;
      font-weight: 400;
      color: #08204d;
      line-height: 40px;
    }
  }
  .coreTechnology-item:nth-child(2n - 1) /deep/.van-cell__title {
    background: url("../../../../static/img/ecological/ecological_coreTechnology_bg1.png")
      no-repeat left center / 100%;
  }
  .coreTechnology-item:nth-child(2n) /deep/.van-cell__title {
    background: url("../../../../static/img/ecological/ecological_coreTechnology_bg2.png")
      no-repeat left center / 100%;
  }
  .coreTechnology-item-check {
    /deep/.van-cell__title::before {
      content: "";
      position: absolute;
      bottom: 0;
      left: 35%;
      width: 30%;
      height: 2px;
      background-color: #4256f1;
    }
  }
  .introduction,
  .purpose {
    .title {
      font-size: 26px;
      color: #08204d;
      line-height: 36px;
      text-align: center;
    }
    .content {
      margin-top: 20px;
      font-size: 24px;
      color: #08204d;
      line-height: 40px;
    }
    .highlight {
      margin-top: 20px;
      font-size: 24px;
      font-weight: 500;
      color: #4256f1;
      line-height: 40px;
    }
  }
  .introduction {
    font-weight: 400;
  }
  .purpose {
    margin-top: 44px;
    font-weight: 400;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/ecological/coreTechnology/coreTechnologyItem.vue